import { fullDateValue } from "./date";
import { COUNTRY_CODE } from "../constants/phoneNumber";
export const onlyStrings = items => items.filter(value => !!value);
export const joinStringsWith = (items, separator) => onlyStrings(items).join(separator);
export const joinStringsWithComma = items => joinStringsWith(items, ", ");
export const formatMessage = (template, ...args) => template.replace(/{(\d)}/g, (s, num) => args[num]);
export const separateSentence = text => text.replace(/([.?!])\s*(?=[A-Z])/g, "$1|").split("|");
export const getStreetWithPostcode = address => {
  const {
    town
  } = address;
  return joinStringsWithComma([getAddressLine1String(address), town]);
};
export const getAddressLine1String = ({
  organisation,
  property,
  street
}) => {
  const propertyWithStreet = [property, street].join(" ").trim();
  return joinStringsWithComma([organisation, propertyWithStreet]);
};
export const getDateString = date => {
  const {
    year,
    month,
    dayOfWeek,
    dayNumber
  } = fullDateValue(date);
  return `${dayOfWeek} ${dayNumber} ${month} ${year}`;
};
export const SHORTEST_VALID_UK_PHONE_NUMBER_REGEXP = /[^\d{7}]?(7[0-9]{9})$/;
export const phoneNumberWithUkCountryCode = (phoneNumber = "") => {
  // formats phone number and returns in format +447123456789
  const result = phoneNumber.match(SHORTEST_VALID_UK_PHONE_NUMBER_REGEXP) || [];
  return result.length > 1 ? `${COUNTRY_CODE.UK}${result[1]}` : null;
};
export function formatOrdinalNumber(i) {
  const j = i % 10;
  const k = i % 100;

  if (j === 1 && k !== 11) {
    return i + "st";
  }

  if (j === 2 && k !== 12) {
    return i + "nd";
  }

  if (j === 3 && k !== 13) {
    return i + "rd";
  }

  return i + "th";
}